import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';

import Form from 'UI/molecules/Form';

const CompanyField = forwardRef((props, ref) => {
  const { t } = useTranslation('userDataCard');

  const { errors, ...other } = props;

  return (
    <Form.Field>
      <Form.Label htmlFor="form_company">
        {t('form.step2.company.label')} *
      </Form.Label>
      <Form.Control>
        <Form.Input
          error={errors.company}
          id="form_company"
          name="company"
          ref={ref}
          {...other}
          placeholder={t('form.step2.company.placeholder')}
        />
        {errors.company && <Form.Error>{errors.company?.message}</Form.Error>}
      </Form.Control>
    </Form.Field>
  );
});

CompanyField.displayName = 'CompanyField';

CompanyField.propTypes = {
  errors: PropTypes.array,
};

export default CompanyField;
